<template>
  <div class="file_container">
    <van-nav-bar
      title="我的意向单"
      @click-left="$router.push('/')"
      left-arrow
      safe-area-inset-top
      placeholder
    />
    <!-- <div class="search">
      <van-search
        show-action
        shape="round"
        label=""
        background="#f0f0f0"
        placeholder="请输入护理员姓名或年龄"
        @search="onSearch"
        @input="input"
        v-model="value"
      >
        <template #action>
          <div @click="value ? onSearch() : ''" class="btnSearch">搜索</div>
        </template>
      </van-search>
      <van-dropdown-menu>
        <van-dropdown-item
          @change="closed(value1)"
          v-model="value1"
          :options="option1"
        />
      </van-dropdown-menu>
    </div> -->
    <div class="box_container">
      <block v-if="result.records.length > 0">
        <div
          class="box"
          v-for="(item, index) of result.records"
          :key="index"
        >
          <div class="b_center">
            <div class="b_center_title">姓名: {{ item.name }}</div>
            <div class="b_center_title">医保卡: {{ item.idCard }}</div>
            <div class="b_center_title">客户手机号: {{ item.mobile }}</div>
          </div>

          <div class="btn_item">
            <van-button
              color="linear-gradient(0deg, #6EAEFC, #6875F1)"
              round
              :to="{
                path: '/selfListDetail',
                query: { res: item },
              }"
            >
              详情
            </van-button>
          </div>
        </div>
      </block>
      <van-empty description="暂无意向单" v-else />
    </div>
    <div class="page" v-if="result.total > 1">
      <van-pagination
        v-model="currentPage"
        :total-items="result.total"
        :show-page-size="3"
        force-ellipses
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import { selfList } from "@/api/index";
export default {
  name: "",
  components: {},
  data() {
    return {
      value: "",
      formData: {
        // pageNo: 1,
        pageSize: 5,
      },
      result: {},
      currentPage: 1,

      value1: "",
      option1: [],
    };
  },
  created() {
      this.init();
  },
  methods: {
    //页面数据初次请求
    init() {
      selfList(this.formData).then((res) => {
          // console.log('res',res);
        if (res.data.success) {
          this.result = res.data.result;
          // console.log(this.result);
        }
      });
    },
    closed(e) {
      this.formData.storeId = e;
      this.init();
    },
    onSearch() {
      this.formData.name = this.value;
      this.init();
    },
    input(e) {
      if (e == "") {
        this.formData.name = "";
        this.init();
      }
    },
    change(e) {
      this.formData.pageNo = e;
      this.init();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.file_container {
  background-color: rgba(232, 232, 232, 0.815);
  min-height: 100vh;
}

/deep/ .van-nav-bar {
  background: #0dacf4;

  .van-nav-bar__title {
    color: #fff;
  }
}

/deep/ .van-nav-bar__left {
  .van-icon {
    color: #fff;
  }
}

/deep/ .van-search__content {
  border: 1px solid #4cc5f8;
}

/deep/ .btnSearch {
  position: relative;
  margin-left: -60px;
  background: linear-gradient(-90deg, #84f5de, #4cc5f8);
  z-index: 99;
  text-align: center;
  color: white;
  border-radius: 0 18px 18px 0;
  border: 1px solid #4cc5f8;
}

.box_container {
  width: 100%;

  .box {
    width: 9.22667rem;
    height: 4.18667rem;
    background: #ffffff;
    border-radius: 0.16rem;
    margin: 0.37333rem;

    .b_center {
      font-size: 0.42667rem;
      padding: 0.53333rem 0.42667rem 0 0.42667rem;
      .b_center_title{
        color: #666666;
        line-height: 0.72rem;
      }
    }

    .btn_item {
      margin: 0 auto;
      width: 2rem;
      /deep/ .van-button {
        width: 62px;
        height: 28px;
        margin-top: 10px;
        .van-button--round {
          border-radius: 20px;
        }
      }
    }

    .d_right {
      width: 28px;
      height: 28px;
      background: linear-gradient(-90deg, #84f5de, #4cc5f8);
      border-radius: 50%;

      &::before {
        content: ">";
        width: 20px;
        height: 20px;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        margin-left: 6px;
      }
    }
  }
}
.page {
  margin-top: 20px;
}
</style>
